import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { connect } from 'react-redux';
import { show_toast } from 'console/dialogs/toast';
import './longpress.sass';
import * as classnames from 'classnames';
import { isMobileApp } from 'utils';
const longpress_delay = 1000;
class LongPressButtonImpl extends React.Component {
    press_time;
    presstimer;
    constructor(props) {
        super(props);
        this.state = { pressed: false };
    }
    on_touch_start = () => {
        if (this._use_longpress()) {
            this.on_pressed();
        }
    };
    on_touch_end = () => {
        if (this._use_longpress()) {
            this.on_released();
        }
    };
    on_pressed = () => {
        if (this._use_longpress()) {
            this.setState({ pressed: true });
            if (this._use_longpress() && this.presstimer == null) {
                this.press_time = new Date();
                this.presstimer = setTimeout(this.on_timeout, longpress_delay);
            }
            return false;
        }
        return false;
    };
    clear_timer() {
        if (this.presstimer != null) {
            clearTimeout(this.presstimer);
            this.presstimer = null;
        }
    }
    on_released = () => {
        if (this._use_longpress()) {
            this.setState({ pressed: false });
            if (this.presstimer != null) {
                this.clear_timer();
                if (new Date().getTime() - this.press_time.getTime() > longpress_delay)
                    this.on_timeout();
                else
                    this.props.onShowToast('Удерживайте кнопку чтобы вызвать действие');
            }
        }
    };
    on_timeout = () => {
        this.clear_timer();
        this.props.onClick?.();
        navigator.vibrate?.(400);
        this.on_released();
    };
    on_touch_move = (ev) => {
        const me = ev.currentTarget.getBoundingClientRect();
        // @ts-ignore
        for (const touch of ev.targetTouches) {
            if (me.left > touch.clientX ||
                touch.clientX > me.right ||
                me.top > touch.clientY ||
                touch.clientY >= me.bottom) {
                this.on_released();
                return;
            }
        }
    };
    _use_longpress() {
        return this.props.longpress_enabled && this.props.enabled;
    }
    render() {
        const add_props = {};
        if (this._use_longpress()) {
            add_props.onContextMenu = (ev) => {
                ev.preventDefault();
                ev.stopPropagation();
            };
        }
        return (_jsxs("div", { className: classnames(this.props.className, 'longpress-button', {
                pressed: this.state.pressed,
            }), ...add_props, onMouseDown: this.on_pressed, onTouchStart: this.on_touch_start, onMouseLeave: this.on_released, onMouseUp: this.on_released, onTouchEnd: this.on_touch_end, onTouchCancel: this.on_released, onTouchMove: this.on_touch_move, onClick: this._use_longpress() ? undefined : this.props.onClick, style: this.props.style, children: [this.props.enabled ? (this.props.square ? (_jsxs(_Fragment, { children: [_jsx("div", { className: "rotor" }), _jsx("div", { className: "stator" }), _jsx("div", { className: "mask" })] })) : (_jsx("div", { className: "filler" }))) : undefined, _jsx("div", { style: { position: 'relative' }, children: this.props.children })] }));
    }
}
export const LongPressButton = connect((state) => ({
    longpress_enabled: state.ui_settings.longpress ?? isMobileApp(),
    /*||
        !!navigator.maxTouchPoints ||
        'ontouchstart' in document.documentElement*/
}), { onShowToast: show_toast })(LongPressButtonImpl);
